import { FC, MutableRefObject } from "react";
import { Box } from "@mui/material";

import { Theme } from "@analyticsMD/quil";
import { ErrorBoundary } from "react-error-boundary";

import APIContextProvider from "../../contexts/APIContext/Provider";
import QCardContent from "./qcard-content";
import ErrorPage from "../error-page";
import EmbededAppContainer from "../embedded-container";
import PatientListEntry from "../../types/PatientListEntry";
import { ReactNode } from "react-markdown";

const sxStyles = {
  wrapper: { display: "flex", flexDirection: "column", height: "100%" },
};

interface PatientDrawerProps {
  patient: PatientListEntry | null;
  updateRef: MutableRefObject<Record<string, any>>;
  closeButtonCmpt: ReactNode;
}

const PatientDrawer: FC<PatientDrawerProps> = ({
  patient,
  updateRef,
  closeButtonCmpt,
}) => {
  if (!patient) return null;

  const ErrorWithClose = () => (
    <ErrorPage closeButtonCmpt={closeButtonCmpt} includeHeader={true} />
  );

  return (
    <Theme>
      <Box sx={sxStyles.wrapper}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <APIContextProvider
            key={patient.emr_patient_id}
            emrPatientID={patient.emr_patient_id}
            emrHospitalID={patient.emr_hospital_id}
            fhirPatientID={patient.fhir_patient_id}
            authContextID={null}
          >
            <ErrorBoundary FallbackComponent={ErrorWithClose}>
              <EmbededAppContainer>
                <QCardContent
                  useSidebarView={true}
                  updateRef={updateRef}
                  closeButtonCmpt={closeButtonCmpt}
                />
              </EmbededAppContainer>
            </ErrorBoundary>
          </APIContextProvider>
        </Box>
      </Box>
    </Theme>
  );
};

export default PatientDrawer;
